import type { CommentFile, Comment } from 'src/models/comment';
import type { CommentDamageRank } from 'src/consts/comment_damage_rank';

export interface CommentFileResponse {
  id: number;
  comment_id: number;
  file_path: string;
  file_name: string | null;
}

export interface CommentResponse {
  id: number;
  angle: number | null;
  comment_type: string;
  content: string;
  direction: string | null;
  g1id: number;
  g2id: number;
  g2name: string;
  g3id: number;
  g3name: string;
  image1_path: string | null;
  damage_rank: CommentDamageRank | null;
  kp_calc: number | null;
  kp_uid: string | null;
  lat: string;
  lon: string;
  movie_id: number | null;
  parent_id: number | null;
  road_name_disp: string | null;
  share_scope: number;
  source_type: string;
  ts: Date;
  user_display_name: string;
  user_id: number;
  user_role: number;
  comment_files: CommentFileResponse[];
}

export type CommentIndexResponse = CommentResponse[];

export const toCommentFile = (response: CommentFileResponse): CommentFile => ({
  id: response.id,
  commentId: response.comment_id,
  filePath: response.file_path,
  fileName: response.file_name,
});

export const toComment = (response: CommentResponse): Comment => ({
  id: response.id,
  angle: response.angle,
  commentType: response.comment_type,
  content: response.content,
  direction: response.direction,
  groupInfo: {
    g1id: response.g1id,
    g2id: response.g2id,
    g2name: response.g2name,
    g3id: response.g3id,
    g3name: response.g3name,
  },
  image1Path: response.image1_path,
  damageRank: response.damage_rank,
  kpCalc: response.kp_calc,
  kpUid: response.kp_uid,
  location: { lat: response.lat, lon: response.lon },
  movieId: response.movie_id,
  parentId: response.parent_id,
  roadNameDisp: response.road_name_disp,
  shareScope: response.share_scope,
  sourceType: response.source_type,
  ts: response.ts,
  userDisplayName: response.user_display_name,
  userId: response.user_id,
  userRole: response.user_role,
  commentFiles: response.comment_files.map(toCommentFile),
});
